import { useField } from "formik";
import { Input } from "antd";
import React from "react";

type TextFieldProps = {
    name: string;
    placeholder?: string;
};

export const TextField: React.FC<TextFieldProps> = (props): JSX.Element => {
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input> and also replace ErrorMessage entirely.
    const [field] = useField(props);
    return <Input {...field} {...props} className={"rmxo-input"} />;
};

export const NumberField: React.FC<TextFieldProps> = (props): JSX.Element => {
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input> and also replace ErrorMessage entirely.
    const [field] = useField(props);
    return <Input pattern="[0-9]*" {...field} {...props} className={"rmxo-input"} />;
};
